import { MapUiTheme } from '../../../common';

export const heroTheme = {
  head: {
    marginTop: (theme: MapUiTheme) => theme.spacing['9'],
    marginBottom: (theme: MapUiTheme) => theme.spacing['9'],
  },
};
